export default {"src":"/_next/static/media/FTNT.cb34225b.svg","height":18,"width":18};